import { createSelector } from 'reselect'
import getCurrentReduxSelector from '../get-current'
import { getIdReduxUtil } from '../../utils/get-id'

export function getCurrentIdReduxSelector (domainMapPath, domainCurrentPath) {
  return createSelector(
    getCurrentReduxSelector(domainMapPath, domainCurrentPath),
    (instance) => getIdReduxUtil(instance)
  )
}
